module.exports = __webpack_public_path__ + "static/hostel-room-showcase-6f1c2f4df829189128a8655ddf574a55.jpeg";